const LIB_HEADER = `/**
 * کتابخانه‌های سراسری (بدون require):
 *   period.current()  → { year, month, day } شمسی Asia/Tehran
 *   commission.calculateAll({ year, month, formula_key })
 *   commission.calculate({ personnel_id, year, month, formula_key })
 *   formulas.load(key) | formulas.list()
 *   jobs.sendPool(task) | jobs.incompleteTargets(task) | jobs.systemHealth(task)
 *   db.query(sql, params)  → rows
 *   log(...)  helpers.daysInMonth(y, m)  helpers.roundRial(n)
 *   task  → همین وظیفه (id, cron, type, formula_key, …)
 *   main  → تابع اصلی همین نوع وظیفه (از function_code)
 */`;

export const TASK_FUNCTION_DEFAULTS = {
  send_pool: `${LIB_HEADER}

async function main(t) {
  return jobs.sendPool(t || task);
}
`,
  incomplete_targets: `${LIB_HEADER}

async function main(t) {
  return jobs.incompleteTargets(t || task);
}
`,
  system_health: `${LIB_HEADER}

async function main(t) {
  return jobs.systemHealth(t || task);
}
`,
  personnel_commission: `${LIB_HEADER}

async function main(opts) {
  const p = period.resolve(opts || {});
  const formulaKey = (opts && opts.formula_key) || task.formula_key || "personnel_commission";
  log("personnel commission main", { year: p.year, month: p.month, formulaKey });
  return commission.calculateAll({
    year: p.year,
    month: p.month,
    formula_key: formulaKey,
    persist: !(opts && opts.persist === false),
  });
}
`,
  custom: `${LIB_HEADER}

async function main(opts) {
  const p = period.resolve(opts || {});
  log("custom main", task.id, { year: p.year, month: p.month });
  return { ok: true, year: p.year, month: p.month };
}
`,
};

export const TASK_SCRIPT_DEFAULTS = {
  send_pool: `return await main(task);
`,
  incomplete_targets: `return await main(task);
`,
  system_health: `return await main(task);
`,
  personnel_commission: `const { year, month } = period.current();
log("personnel commission", { year, month, formula: task.formula_key });
const result = await main({ year, month, formula_key: task.formula_key });
return {
  year,
  month,
  count: (result.results || []).length,
  paid: result.fields && result.fields.commission_paid,
  allocated: result.fields && result.fields.commission_allocated,
  sale: result.fields && result.fields.commission_sale,
  active: result.fields && result.fields.commission_active,
  claims: result.fields && result.fields.commission_claims,
};
`,
  custom: `const { year, month } = period.current();
log("custom job", task.id, { year, month });
return await main({ year, month });
`,
};

function stripHeader(src) {
  return String(src || "")
    .replace(/\/\*\*[\s\S]*?\*\//, "")
    .replace(/\s+/g, " ")
    .trim();
}

export function scriptForType(type) {
  return TASK_SCRIPT_DEFAULTS[type] || TASK_SCRIPT_DEFAULTS.custom;
}

export function functionForType(type) {
  return TASK_FUNCTION_DEFAULTS[type] || TASK_FUNCTION_DEFAULTS.custom;
}

export function isDefaultScript(code, type) {
  const current = stripHeader(code);
  if (!current) return true;
  return (
    Object.values(TASK_SCRIPT_DEFAULTS).some((s) => stripHeader(s) === current) ||
    (TASK_SCRIPT_DEFAULTS[type] && stripHeader(TASK_SCRIPT_DEFAULTS[type]) === current)
  );
}

export function isDefaultFunction(code, type) {
  const current = stripHeader(code);
  if (!current) return true;
  return (
    Object.values(TASK_FUNCTION_DEFAULTS).some((s) => stripHeader(s) === current) ||
    (TASK_FUNCTION_DEFAULTS[type] && stripHeader(TASK_FUNCTION_DEFAULTS[type]) === current)
  );
}

export const CODE_SNIPPETS = [
  {
    id: "period",
    label: "ماه جاری شمسی",
    code: "const { year, month, day } = period.current();",
  },
  {
    id: "commission-all",
    label: "پورسانت همه فروشنده‌ها",
    code: "const result = await commission.calculateAll({ year, month, formula_key: task.formula_key });",
  },
  {
    id: "commission-one",
    label: "پورسانت یک پرسنل",
    code: "const one = await commission.calculate({ personnel_id: task.personnel_id, year, month, formula_key: task.formula_key });",
  },
  {
    id: "formulas-load",
    label: "بارگذاری فرمول",
    code: "const formula = await formulas.load(task.formula_key || \"personnel_commission\");",
  },
  {
    id: "main",
    label: "فراخوانی تابع اصلی",
    code: "return await main({ year, month, formula_key: task.formula_key });",
  },
  {
    id: "db",
    label: "کوئری SQL",
    code: "const rows = await db.query(\n  \"SELECT COUNT(*)::int AS n FROM sales_calculation_result WHERE year_number=$1 AND month_number=$2\",\n  [year, month],\n);",
  },
  {
    id: "send-pool",
    label: "ارسال صف اعلان",
    code: "return await jobs.sendPool(task);",
  },
];
